/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Alert } from 'reactstrap';
import classnames from 'classnames';
import CustomModal from '../../../CustomModal';

const VoipMonActivityLogs = ({ cdrVoipMonLogs = [], svgData, svgModelOpen, setSvgModelOpen, setCallID, activeTab, setActiveTab, setPcapDateValid,selectedRowData }) => {
  const { total, success, results } = cdrVoipMonLogs;

  const showPcap = (item) => {
    if(!item || !item.calldate){
      setPcapDateValid(false)
      return
    }

    const currentDate = new Date();
    const dateLimit = currentDate.setDate(currentDate.getDate() - 3);
    const callDate = new Date(item.calldate);

    if(callDate < dateLimit){
      setPcapDateValid(false)
      return
    }

    setPcapDateValid((true))
  }

  const toggle = (tab, item) => {
    if (activeTab !== tab) {
      setCallID(item.ID);
      setActiveTab(tab);
      showPcap(item)
    };
  };

  if(!!results && results.length){
    setCallID(results[activeTab-1]?.ID);
    showPcap(results[activeTab-1])
  }
  
  return (
    <>
    <div className="table-header-fixed cdr-activity-logs">
      {total && success ? (
        <>
          <Nav tabs>
            {results?.map((item, idx) => {
              const calls = idx + 1;
              return (
                <NavItem className="cursor-pointer" key={idx}>
                  <NavLink
                    className={classnames({ active: activeTab === calls })}
                    onClick={() => {
                      toggle(calls, item);
                    }}
                  >
                    <strong>Call {calls}</strong>
                  </NavLink>
                </NavItem>
              );
            })}
          </Nav>
          <TabContent activeTab={activeTab}>
            {results.map((items, index) => {
              const callCount = index + 1;
              return (
                <TabPane tabId={callCount} key={index}>
                  <Row>
                    <Col md={4} sm={12}>
                      <strong>DataCenter</strong>
                    </Col>
                    <Col md={4} sm={12}>
                      <span>{selectedRowData?.datacenter || 'N/A'}</span>
                    </Col>
                  </Row>
                  {Object.entries(items).map((item, idx) => {
                    return (
                      <Row key={idx}>
                        <Col md={4} sm={12}>
                          <strong>{item[0]}</strong>
                        </Col>
                        <Col md={4} sm={12}>
                          {item[0] === 'allrtpstreams' ||
                          item[0] === 'orig_allrtpstreams' ||
                          item[0] === 'allsiprequests' ? (
                            JSON.parse(item[1])?.map(subItems => {
                              return Object.entries(subItems).map((subItem, subIdx) => {
                                return (
                                  <Row key={subIdx}>
                                    <Col md={6} sm={12}>
                                      <strong>{subItem[0]}</strong>
                                    </Col>
                                    <Col md={6} sm={12}>
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            subItem[1]
                                              ?.toString()
                                              .replace(/<img[^>]*>/g, '')
                                              .replace(/(?:https?|ftp):\/\/[\n\S]+/g, '') || 'null',
                                        }}
                                      />
                                    </Col>
                                  </Row>
                                );
                              });
                            })
                          ) : (
                            <span
                              dangerouslySetInnerHTML={{
                                __html:
                                  item[1]
                                    ?.toString()
                                    .replace(/<img[^>]*>/g, '')
                                    .replace(/(?:https?|ftp):\/\/[\n\S]+/g, '') || 'null',
                              }}
                            />
                          )}
                        </Col>
                      </Row>
                    );
                  })}
                </TabPane>
              );
            })}
          </TabContent>
        </>
      ) : (
        <Alert color="info">No CDR Logs Activity Found!</Alert>
      )}
    </div>
    <CustomModal
        isOpen={svgModelOpen}
        onCancel={() => setSvgModelOpen(false)}
        medium
        close
        onClick={()=>{}}
      >
        {/* <img src={analyticsImage} alt="Analytics" /> */}
        <div dangerouslySetInnerHTML={{ __html: svgData }} className='cdr-callflow-svg' />
      </CustomModal>
    </> 
  );
};

export default VoipMonActivityLogs;
